import { useEffect } from "react";
import { type MotionValue, animate, useMotionValue } from "motion/react";

const inactiveShadow = "0px 0px 0px 0px rgb(0 0 0 / 0)";

export function useRaisedShadow(value: MotionValue<number>) {
	const boxShadow = useMotionValue(inactiveShadow);

	useEffect(() => {
		let isActive = false;
		value.on("change", (latest) => {
			const wasActive = isActive;
			if (latest !== 0) {
				isActive = true;
				if (isActive !== wasActive) {
					animate(boxShadow, "0px 10px 15px -3px rgb(0 0 0 / 0.1)");
				}
			} else {
				isActive = false;
				if (isActive !== wasActive) {
					animate(boxShadow, inactiveShadow);
				}
			}
		});
	}, [value, boxShadow]);

	return boxShadow;
}
